<template>
  <BookingShortItemLayout>
    <KwGradient slot="image">
      <div class="image"></div>
    </KwGradient>
    <div class="line-1">
        <div class="left">
          <KwGradient />
        </div>
        <div class="right">
          <KwGradient/>
        </div>
    </div>
    <div class="line-2">
      <div class="left">
        <KwGradient />
      </div>
    </div>
    <div class="line-3">
      <div class="left">
        <div class="subline-1">
          <KwGradient />
        </div>
        <div class="subline-2">
          <KwGradient />
        </div>
        <div class="subline-3">
          <KwGradient />
        </div>
      </div>
      <div class="right">
        <div class="subline-1">
          <KwGradient />
        </div>
      </div>
    </div>
  </BookingShortItemLayout>
</template>

<script>
import KwGradient from '@/components/KwGradient.vue';
import BookingShortItemLayout from './BookingShortItemLayout.vue';

export default {
  name: 'BookingLoader',
  components: {
    KwGradient,
    BookingShortItemLayout,
  },
};
</script>

<style lang="scss" scoped>
  .image {
    width: 240px;
    height: 212px;
    @include media-breakpoint-between(xs, sm) {
      display: none;
    }
  }
  .line-1 {
    display: flex;
    justify-content: space-between;
    min-width: 300px;
    min-height: 40px;
    .left {
      height: 25px;
      width: 60%;
    }
    .right {
      height: 40px;
      width: 20%;
      @include media-breakpoint-between(xs, sm) {
        display: none;
      }
    }
  }
  .line-2 {
    .left {
      height: 25px;
      width: 40%;
    }
  }
  .line-3 {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 10px;
    @include media-breakpoint-between(xs, sm) {
      flex-direction: column;
      align-items: flex-start;
    }
    .left {
      display: flex;
      flex-direction: column;
      width: 55%;
      @include media-breakpoint-between(xs, sm) {
        width: 100%
      }
      .subline-1 {
        width: 50%;
        @include media-breakpoint-between(xs, sm) {
          width: 70%
        }
      }
      .subline-2 {
        @include media-breakpoint-between(xs, sm) {
          width: 65%
        }
      }
      .subline-3 {
        @include media-breakpoint-between(xs, sm) {
          width: 85%
        }
      }
      .subline-1, .subline-2, .subline-3 {
        height: 20px;
        margin: 10px 0;
      }
    }
    .right {
      width: 20%;
      @include media-breakpoint-between(xs, sm) {
        width: 100%
      }
      .subline-1 {
        height: 40px;
      }    }
  }
</style>



// WEBPACK FOOTER //
// src/views/BookingList/components/BookingLoader.vue